import type { FaireProductEntity } from "../../entity_types/product";

export const p_bfntr9eqh5: FaireProductEntity = {
  token: "p_bfntr9eqh5",
  type: "product",
  name: "Ceramic Vase, Olives",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/fd6342329c063540e94fd7f0d6d9ac8e8647fd79b7273b509c20d1793a3df6a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c775b0bd64a260e64db3550cfda1209a7cddb47d4c63596bbfdab14e824e5846.jpeg",
    "https://cdn.faire.com/fastly/232c4fcc1ec2955b3ebf20948ee839c583cbd03ffa5a1634c66a740b0819c279.jpeg",
    "https://cdn.faire.com/fastly/aedd74622f43db81a32e5f97e7f6ea00c8652c7a73727ea7646932e0c3c5f3f9.jpeg",
    "https://cdn.faire.com/fastly/182891c67631ef7db0248a8667fdefb5caf3154ee67bd8fd685825bde8e0365d.jpeg",
    "https://cdn.faire.com/fastly/7f090d2e7151323c9b8d8df20863bddf7cd28ccd1c1da156b02e618db5689f1c.jpeg"
  ],
  priceDollars: 14,
  description: "A little-known fact: olives probably love flowers. This Bando ceramic vase proves it! Shaped and styled with that signature Bando charm, it’s the cutest addition to any kitchen table, desk, or shelf. Made of high-quality ceramic, it’s perfect for holding blooms, greenery, or even your favorite pens and pencils. Equal parts quirky and chic, it’s a playful pop of joy for any space.\n\nFeatures:\n\nMade of durable, high-quality ceramic\n\nOlive-inspired design adds a fun, unexpected twist\n\nPerfect for flowers, plants, or desktop organization\n\nAdds a pop of charm and personality to any room\n\nDesigned in Bando’s signature cheerful aesthetic\n\n\nIdeal For:\n\nGift shops and home décor boutiques\n\nLifestyle retailers and floral studios\n\nKitchen and dining stores with a playful aesthetic\n\nWholesale buyers looking for unique, design-forward home accents",
  tags: [],
  msrpDollars: 28.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:17.532Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
